Ext.define('SA.view.SupportMenu', {
    alias: 'widget.support-menu',
    extend: 'Ext.menu.Menu',

    items: [
        {
            itemId: 'chatItem',

            handler() {
                SA.Olark.openChat();
            }
        }, {
            text: 'Help Center',
            href: 'https://simplyanalytics.zendesk.com/hc/en-us',
            hrefTarget: '_blank',

            listeners: {
                boxready() {
                    var localizedText = SA.localize(this.text);

                    this.setText(localizedText);
                }
            },

            afterRender() {
                this.itemEl.set({rel: 'noopener noreferrer'});
            }
        }, {
            text: 'Contact Support',

            handler() {
                zE.activate({hideOnClose: true});
            }
        }, {
            text: 'Data Documentation',

            handler() {
                Ext.widget({xtype: 'data-docs-window'});
            }
        }, {
            text: 'Replay Tutorial',

            handler() {
                Ext.widget({xtype: 'tutorial'});
            }
        }, {
            xtype: 'menu-svg-icon-item',
            text: 'Download Training Guide',
            href: SA.Assets.getPath('documents/SimplyAnalytics_Exercise_Guide_-_Answering_Research_Questions.pdf'),
            icon: 'sa-icon-pdf'
        }, {
            xtype: 'menuseparator'
        }, {
            xtype: 'menu-svg-icon-item',
            text: 'Intro to SimplyAnalytics (5:12)',
            icon: 'sa-icon-video',

            handler() {
                Ext.widget({xtype: 'video-window'});
            }
        }, {
            xtype: 'menu-svg-icon-item',
            href: 'https://vimeo.com/user68002385/simplyanalytics-historical-mode?share=copy',
            hrefTarget: '_blank',
            icon: 'sa-icon-video',
            text: '“Historical Mode” Video (Access to Premium Data)',

            afterRender() {
                this.itemEl.set({rel: 'noopener noreferrer'});
            }
        }
    ],

    beforeShow() {
        var chatItem = this.down('#chatItem'),
            chatAvailable = SA.Olark.isAvailable();

        this.callParent();

        chatItem.setDisabled(!chatAvailable);
        chatItem.setText(chatAvailable ? 'Live Chat!' : 'Live Chat (Offline)');
    }
});